import { render, staticRenderFns } from "./appfix.vue?vue&type=template&id=59367fda&scoped=true"
import script from "./appfix.vue?vue&type=script&lang=js"
export * from "./appfix.vue?vue&type=script&lang=js"
import style0 from "./appfix.vue?vue&type=style&index=0&id=59367fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59367fda",
  null
  
)

export default component.exports